// extracted by mini-css-extract-plugin
export default {"overlay":"dB-z","bodyOpen":"eB-z","content":"fB-z","header":"gB-z","closeNoHeading":"hB-z"};